<template>
    <v-form>
        <v-container>
            <v-row>
                <v-col>
                <h2>Create Test User</h2>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-text-field
                            v-model="partnerId"
                            :rules="partnerIdRules"
                            :counter="8"
                            label="Partner Id"
                            required
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-spacer></v-spacer>
                <v-btn class="mr-3" color="primary" @click="createUser">Create User</v-btn>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import constants from "../constants";
    export default {
        name: "CreateUserView",
        data: () => ({
            partnerId: '',
            partnerIdRules: [
                v => v.length === 8 || v.length === 0 || 'Partner Id must be exactly 8 characters or left empty',
            ]
        }),
        methods: {
            randomString(length) {
                const alphabet = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                let result = '';
                for (let i = length; i > 0; --i) result += alphabet[Math.floor(Math.random() * alphabet.length)];
                return result;
            },
            createUser() {
                if(this.partnerId.length === 0 || this.partnerId.length === 8) {
                    this.partnerId = this.partnerId ? this.partnerId : this.randomString(8);
                    this.$http.post(constants.ACCOUNT_ENDPOINT, {
                        partnerId: this.partnerId
                    }, {
                        withCredentials: true
                    })
                        .then(() => {
                            this.$store.commit('setSuccessMessage', "Created test user " + this.partnerId)
                        })
                        .catch(error => {
                            this.$store.commit('setErrorMessage', error.response.data.message + '\n' + error.response.data.description)
                        });
                } else {
                    this.$store.commit('setErrorMessage', 'Partner id must be left empty or exactly 8 characters long')
                }
            }
        }
    }
</script>

<style scoped>

</style>
